<div class="header p-d-flex" *ngIf="headerFlag">
  <div class="main">
    <div class="main-content">
      <div class="p-fluid p-formgrid p-grid header-content" [ngClass]="{'p-jc-center':checkLanding() || isA201(), 'guest-mobile-header': checkLanding() || (isA201() && !user)}">
        <div class=" header-title-large" [ngClass]="{'p-col-2':!checkLanding()&& !isA201()}">
          <img
            alt="ロゴ"
            class="header-text-title"
            src="../../../../assets/images/logo_image.png"
            (click)="navigateToHome()"
            style="cursor: pointer;"
            />
        </div>

        <div class="mobile-auth-buttons-inline p-grid p-nogutter" *ngIf="checkLanding() || (isA201() && !user)">
          <div class="p-col-6 p-px-2">
            <button
              pButton
              pRipple
              type="button"
              label="利用登録"
              class="p-button-raised mobile-register-button"
              (click)="moves('pages/platform/a201')"
            ></button>
          </div>
          <div class="p-col-6 p-px-2">
            <button
              pButton
              pRipple
              type="button"
              label="ログイン"
              class="p-button-raised button-login mobile-login-button"
              (click)="login()"
            ></button>
          </div>
        </div>

        <div class="card p-col-8 header-content-menu" *ngIf="!checkLanding()">
          <p-tabMenu
            [model]="menuList"
            class="tab-menu"
            [activeItem]="activeItem2"
            id="listmenu"
            *ngIf="checkShowMenu()"
          >
            <ng-template
              pTemplate="item"
              let-item
              let-i="index"
              class="tab-template"
            >
            <ng-container *ngIf="item.title2; else oneColumn">
              <div
                [routerLink]="item.link"
                [ngClass]="isActive(item) ? 'active' : ''"
                class="text-white-color"
              >
              <span>{{ item?.title1 }}</span><br/>
              <span>{{ item?.title2 }}</span>
                
              </div>       
            </ng-container>
            <ng-template #oneColumn>
              <div
                [routerLink]="item.link"
                [ngClass]="isActive(item) ? 'active' : ''"
                class="text-white-color"
              >
              <span>{{ item?.title1 }}</span>
              </div>    
            </ng-template>
            
               
            </ng-template>
          </p-tabMenu>
        </div>

        <div
          class="p-col-2 header-list"
          *ngIf="checkShowMenu()"
        >
          <div class="p-fluid p-formgrid p-grid header-content-grid">
            <div class="p-col-6 notice">

              <i
                class="fa-solid fa-bell notice-icon" 
                (click)="openNotificationDialog($event)">
              </i>
              <div class="badge" *ngIf="unread_notification > 0">{{unread_notification <= 9?unread_notification:'9+'}}</div>
            </div>
            <div class="p-col-6 list">
              <button
                #btn
                type="button"
                class="btn-info-sub-menu"
                pButton
                icon="pi pi-bars"
                (click)="menu.toggle($event)"
              ></button>
              <p-tieredMenu
                #menu
                [model]="items"
                [popup]="true"
                class="position: relative;"
              ></p-tieredMenu>
            </div>
          </div>
        </div>
        <div
          class="p-col-4 header-list jc-end landing-header"
          *ngIf="checkLanding()"
        >
          <ng-container *ngFor="let item of guestDesktopHeaderMenu; let i = index">
            <a class="no-decoration">
              <button
                pButton
                type="button"
                [id]="item.id"
                [label]="item.title"
                (click)="item.action(item.id)"
                class="p-button-text header-button-text header-button-text-landing"
                [ngClass]="{
                  'last-item': i === guestDesktopHeaderMenu.length - 1,
                  'second-last-item': i === guestDesktopHeaderMenu.length - 2
                }"
              ></button>
            </a>
          </ng-container>
          
        </div>
      </div>
    </div>
  </div>
  
</div>
<div class="mobile-menu"  *ngIf="headerFlag">
  <p-accordion expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-up">
    <p-accordionTab 
      *ngIf="checkLanding() || (isA201() && !user)" 
      [header]='isOpenMoblieMenu[1]?"メニューを閉じる":"メニューを開く"'
      [(selected)]="isOpenMoblieMenu[1]"
    >
        <ng-container *ngFor="let item of guestMobileHeaderMenu">
          <div class="item" (click)="item.action()">{{item.title}}</div>
        </ng-container>
    </p-accordionTab>
    <p-accordionTab 
      *ngIf="!checkLanding() && !isA201()" 
      [header]='isOpenMoblieMenu[0]?"メニューを閉じる":"メニューを開く"'
      [(selected)]="isOpenMoblieMenu[0]"
    >
      
      <ng-container *ngFor="let item of menuList" >
        <div class="item" (click)="moves(item?.link)">
          {{item.title1 }}{{item.title2?item.title2:""}}
        </div>
      </ng-container>
    </p-accordionTab>
  </p-accordion>
</div>

<app-notification-dialog (reCount)="getCount()"></app-notification-dialog>